import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useFreshness } from '../../hooks/queries/useFreshnessQueries';
import { CORE_SOURCES, problemText } from '../../utils/freshness';

const KEY = 'freshness-banner-hidden';

/**
 * A strip above the page when the tender data is behind (the fetch fails, or nothing new for
 * days) — so nobody reads a stale dashboard as today's. Hidden for the rest of the session once
 * closed; it comes back if the problem changes.
 */
const DataFreshnessBanner: React.FC = () => {
  const { data } = useFreshness();
  const problems = (data?.sources ?? []).filter((s) => CORE_SOURCES.includes(s.key)).map(problemText).filter((t): t is string => !!t);
  const sig = problems.join('|');
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem(KEY); } catch { return null; }
  });
  if (!problems.length || hidden === sig) return null;
  return (
    <div className="fresh-banner" role="status">
      <AlertTriangle size={15} aria-hidden />
      <div className="fresh-banner-text">
        {problems.map((p) => <span key={p}>{p}</span>)}
      </div>
      <button type="button" aria-label="Хаах" title="Энэ удаад хаах"
        onClick={() => { setHidden(sig); try { sessionStorage.setItem(KEY, sig); } catch { /* private mode */ } }}>
        <X size={14} />
      </button>
    </div>
  );
};

export default DataFreshnessBanner;
